import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=ecf06c1e&scoped=true&"
import script from "./TeamsList.vue?vue&type=script&lang=ts&"
export * from "./TeamsList.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=ecf06c1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf06c1e",
  null
  
)

export default component.exports